import { defineNuxtPlugin } from '#app/nuxt'
import { LazyComparisonCartFeatures, LazyTextDivider, LazyCreateTestModal, LazyDuplicateTestModal, LazyEditTestNameModal, LazyEndTestModal, LazyStartTestModal, LazyWidgetSelectionModal, LazyInfoAccordion, LazyLinkAccordion, LazyPayoutAccordion, LazyPayoutAccordionSkeleton, LazyPayoutComparisonChart, LazyPayoutCompositionChart, LazyDeactivateBrandModal, LazyInviteUserModal, LazyAddressHistoryItem, LazyActionObjectSummary, LazyAmountBreakdown, LazyAutomationBarChart, LazyAutomationToolTrace, LazyChartGranularityToggle, LazyClaimAutomationDetail, LazyFeedbackIssuesView, LazySegmentedToggle, LazyAllowedOrderTagsCard, LazyClaimAutomationTabs, LazyEscalationTierStack, LazyStoreModelPicker, LazyBrandAuditModal, LazyScopeIndicator, LazyAccordionSection, LazyActivateStoreModal, LazyAddProtectionModal, LazyBasicQuestionModal, LazyClaimAutomationDetailModal, LazyClaimAutomationFeedbackModal, LazyCreateAdminUser, LazyCreateApiToken, LazyCreateCategory, LazyCreateMacro, LazyCreateStoreModal, LazyCreateWebhook, LazyDeactivateStoreModal, LazyDeleteApiTokenModal, LazyDeleteCategoryModal, LazyDeleteMacro, LazyDeleteSopModal, LazyDeleteWebhookModal, LazyMoveMacroModal, LazyMoveStoreToDevelopmentModal, LazyMoveStoreToOnboardingModal, LazyNewApiTokenModal, LazyReInstallStore, LazyRemoveProtection, LazyRenameCategory, LazyRequestReinstall, LazyResetOverrideMacroModal, LazyUpdateToActiveSopModal, LazyUpdateToInactiveSopModal, LazyWebhookRequestResponse, LazyContactInformation, LazyCreateBigcommerceStore, LazyCreateDefaultStore, LazyCreateShopifyStore, LazyMerchantInformation, LazyDurationSelector, LazyRangeRule, LazyRangeRuleSet, LazyUnifiedPriceRule, LazyUnifiedPriceRuleSet, LazyAccountDashboardFrame, LazyMetricsSummary, LazyRevenueCalculator, LazySignIn, LazyWelcomeBack, LazyAvatarGroup, LazyPlatformAvatar, LazyUserAvatar, LazyFraudRiskBadge, LazyMetadataBadge, LazyNoFraudBadge, LazyProtectionStatusBadge, LazyRiskLevelBadge, LazyStatusBadge, LazyBuilderControl, LazyBuilderEmptyState, LazyBuilderInspector, LazyBuilderNodeRow, LazyBuilderPalette, LazyBuilderTreeCanvas, LazyWidgetBuilderPanel, LazyBasicCard, LazyConciergeCard, LazyChatAttachment, LazyChatImageUploader, LazyMessageBox, LazyClaimPortalBlockView, LazyClaimPortalBuilderCanvas, LazyClaimPortalBuilderPanel, LazyClaimSelectorBlockView, LazyPageSwitcher, LazyAIStatusBadge, LazyAISuggestionBanner, LazyClaimAssignee, LazyClaimFeed, LazyClaimItemCard, LazyClaimMetricRow, LazyClaimPeople, LazyClaimResolutionOptionsRadioGroup, LazyClaimStateBadge, LazyClaimTypeCustomizer, LazyClaimsInfoButton, LazyClaimsTable, LazyCreateClaimButton, LazyEscalationPeek, LazyEscalationRecommendationCard, LazyEscalationReplyBox, LazyFulfillmentInfo, LazyIssueGallery, LazyIssueGalleryCard, LazyItemIssue, LazyPaymentSection, LazyReturnCard, LazyReturnsFeed, LazyReviewResolutionCard, LazySetClaimType, LazyShippingClaim, LazyShippingClaimMetric, LazyShippingClaimPhotos, LazySingleClaim, LazyCustomerAddresses, LazyFulfillmentTable, LazyLiveTrackingStatus, LazySopTab, LazyTrackingInfo, LazyAddPaymentMethod, LazyAddPayoutMethod, LazyApproveClaim, LazyApproveResolveExternallyClaim, LazyClaimsInfoModal, LazyCloseClaim, LazyCreateClaimSuccessModal, LazyCreateInternalClaimModal, LazyDenyClaim, LazyDenySuggestionFeedbackModal, LazyDismissClaim, LazyEditClaimTypeModal, LazyEditCustomerEmail, LazyEditShippingAddress, LazyInStoreShippingClaimModal, LazyInStoreWarrantyModal, LazyMoveToApprovedModal, LazyMoveToClosedModal, LazyMoveToDeniedModal, LazyOnHoldClaim, LazyPendingClaim, LazyPolicyTraceModal, LazyResetClaimModal, LazyShippingAddressHistoryModal, LazyShippingClaimForm, LazyTakeoverReasonModal, LazyToDoClaim, LazyValidateWarrantyModal, LazyWarrantyClaimForm, LazyApproveClaimCustom, LazyFlatRateType, LazyFullDraftOrder, LazyFullFlatRate, LazyFullRefund, LazyFullReship, LazyFullStoreCredit, LazyOverrideShippingAmount, LazyRefundItem, LazyRefundShipping, LazyReshipRefundResolutionDetails, LazyResolutionBreakdown, LazyWarrantiesTable, LazyWarrantyClaim, LazyLoaderBar, LazyCustomerAddressesModal, LazyCustomerDetail, LazyCustomerFilters, LazyCustomerHistoryStrip, LazyCustomerListTable, LazyCustomerMetricCard, LazyCustomerMetricRow, LazyCustomerMetrics, LazyCustomerName, LazyCustomerOrderHistoryTable, LazyCustomerPendingBanner, LazyCustomerProtectedOrderHistoryTable, LazyCustomerSearch, LazyCustomerSortControl, LazyCustomerSummaryTiles, LazyCustomerTable, LazyCustomerTags, LazyDangerThresholdTile, LazyFreshnessStamp, LazyLegacyCustomerDetail, LazyLegacyCustomerList, LazySortResetNotice, LazyUsdMarker, LazyClaimPortalView, LazyFontStyleRadioGroup, LazyMockCartPreview, LazyPageMetadataView, LazyPhoneFrame, LazyPreviewUnavailableNotice, LazyAnalyticsTile, LazyClaimsByTypeTile, LazyTopProductsWithShippingClaimsTile, LazyABTestDataDisplay, LazyDataDisplay, LazyDataMetric, LazyDateFilter, LazyProductDisplay, LazyProductResolution, LazySettingsGeneralTagging, LazyStoreCreditOptions, LazyToggleDisplay, LazyMethodSettings, LazyAddFilterButton, LazyDesktopFilterButton, LazyFilterButton, LazyFilterOptionRow, LazyFilters, LazyMobileFilterButton, LazyResponsiveTable, LazyTableFilter, LazyTablePagination, LazySortButton, LazyAppCard, LazyAppStatusBadge, LazyClientSecretField, LazyCreateAppModal, LazyInviteOrgMember, LazyRedirectUriList, LazyScopeSelector, LazyEmailBlockView, LazyEmailBuilderControl, LazyEmailBuilderEmptyState, LazyEmailBuilderInspector, LazyEmailBuilderPalette, LazyEmailBuilderPanel, LazyEmailBuilderPreview, LazyEmailDesignerSidebar, LazySidebarAccordion, LazySidebarSection, LazyWidgetDesignerSidebar, LazyBillingJobs, LazyJobsList, LazyGlobalMacroCard, LazyGlobalMacroCategoryList, LazyImpersonationBanner, LazyImpersonationTargetModal, LazyThemeRunTerminal, LazyInfoModalBuilderCanvas, LazyInfoModalBuilderPanel, LazyInfoModalDesignerSidebar, LazyInfoModalPreview, LazyDashboardIndex, LazyDashboardIndividual, LazyLightModeOnly, LazyPreviewTemplate, LazySidebarLayout, LazyCodeEditorModal, LazyDeleteInfoModalModal, LazyDraftModal, LazyFreshInstallDeploymentModal, LazyGetCodeModal, LazyInfoModalTypeModal, LazyPublishEmailModal, LazyPublishSuccessModal, LazyPublishWidgetModal, LazySenderSignatureModal, LazySenderSignatureSuccessModal, LazySuccessModal, LazyUnsavedChangesModal, LazyWidgetStyleModal, LazyWidgetTypeModal, LazyDashboardSingleLayout, LazyMacroCard, LazyMacroCategoryButtonMenu, LazyMacroCategoryList, LazyMacroDetails, LazyCategoryFilter, LazyMarketplaceAppCard, LazyAddMacroModal, LazyAutomationEvent, LazyDownloadTranscriptButton, LazyMessagingEvent, LazyMessagingEventDivider, LazyMessagingFeed, LazyMethodList, LazyAddTagModal, LazyConfirmationModal, LazyCreateBrandModal, LazyCreateDeploymentModal, LazyCreateReturnModal, LazyCreateReviewModal, LazyCreateShopifyAppModal, LazyDeleteStoreCreditModal, LazyEditBrandModal, LazyEditWarrantyDurationModal, LazyMFAEmailHelp, LazyMFAHelp, LazyMFAManualCodeModal, LazyMFAVerifyHelp, LazyOrderNotificationSettingsModal, LazyPublishClaimPortalConfirmation, LazyNavAccordion, LazyNavDivider, LazyNavGroupTitle, LazyNavItem, LazyNavItems, LazySideNav, LazyTabbedNav, LazyNotification, LazyNotificationContent, LazyOrdersTable, LazyProtectedOrderItemCard, LazyProtectedOrderMetricRow, LazyProtectionButton, LazyPayoutBillsTable, LazyPayoutInfoModal, LazyPriorCycleCard, LazyReimbursementModal, LazyStatisticTile, LazyCreatePersonalAccessTokenModal, LazyNewPersonalAccessTokenModal, LazyPersonalAccessTokenManager, LazyPersonalAccessTokenTable, LazyRenamePersonalAccessTokenModal, LazyProductsTable, LazySyncShopifyButton, LazyWarrantyCell, LazyWarrantyStatusCell, LazyAverageCard, LazyDistributionCard, LazyMetricsRow, LazyRatingStars, LazyReviewNoteItem, LazyReviewNotesDrawer, LazyTrendCard, LazyAddItemFromOrderModal, LazySearchInput, LazySearchModal, LazySearchProductModal, LazyHalloweenDecor, LazySeasonalLogo, LazyThanksgivingDecor, LazyThanksgivingFeast, LazyThanksgivingPardon, LazyThanksgivingTurkey, LazyCoverageModeSelector, LazyCustomerAcknowledgmentCard, LazyEffectiveWindowBanner, LazyEscalationsSettings, LazyEvidencePill, LazyResolutionValueBasisCard, LazyRiskRoutingCard, LazyShopifyRateTableCard, LazySlackIntegrationCard, LazyCustomTagRuleModal, LazyCustomTagRuleRow, LazyCustomTagsList, LazyPreviewSidebar, LazyStepHeader, LazyTemplateTokenInput, LazyVariableChips, LazyAutomationReason, LazyCodeEditor, LazyCopyText, LazyCustomerAddress, LazyEditButton, LazyMarkdownText, LazyApiTokenCard, LazyApiTokenCardSkeleton, LazyEmptyState, LazyDropArea, LazyMediaUploader, LazyPageIcon, LazySharedFooter, LazyBasicModal, LazySimplePopover, LazySelectionGroup, LazyErrorGroup, LazyGenerateSopsCard, LazyHelpDeskConsentModal, LazySlackChannelChecklist, LazySlackConsentModal, LazySlackSopsCard, LazySopListItem, LazyRedeemedText, LazyAccountRollupHeader, LazyAdminStoreGroupingControls, LazyStoreDisplay, LazyStoreSelect, LazyStoreSelectButton, LazyTeamMembersInfoButton, LazyTeamMembersTable, LazyAccessLevelSelect, LazyUserRoleBadge, LazyCreateTeamMember, LazyTeamMembersEntitlementsCard, LazyTeamMembersInfoModal, LazyThemeSwitch, LazyNotificationToast, LazyToastController, LazyDownloadUploadProducts, LazyPricingAccordion, LazyWarrantyPricingDisplay, LazyWarrantyRuleSelect, LazyWebhookCard, LazyWebhookCardSkeleton, LazyWebhookTopicGroup, LazyCheckoutWidget, LazyIncludedCheckoutPreview, LazyTileFeatureList, LazyPulseAiProductFinderModal, LazyPulseConfirmShippingAddress, LazyPulseDeliveryIssueDetails, LazyPulseDeliveryIssueDropdown, LazyPulseDeliveryIssueOptions, LazyPulseItemCard, LazyPulseItemIssueCard, LazyPulseItemIssueDetailModal, LazyPulseItemIssueDetailModalForm, LazyPulseItemIssueDetailModalProgressBar, LazyPulseItemIssueDetailModalSelectCount, LazyPulseItemIssueDetailModalSelectGranularity, LazyPulseItemIssueDetails, LazyPulseOrderIssueOptions, LazyPulseProductNotFoundForm, LazyPulseRendered, LazyPulseResolutionOptions, LazyPulseSearchWarrantyProductsModal, LazyPulseShippingAddress, LazyPulseUnavailableItemsResolution, LazyPulseUploadedReceipts, LazyPulseContactInfoStep, LazyPulseDateOfPurchaseStep, LazyPulseProductSearchStep, LazyPulseReceiptStep, LazyPulseReceiptUploadSection, LazyPulseResolutionStep, LazyPulseBadge, LazyPulseEmptyState, LazyPulseLoadingSpinner, LazyPulseMediaCarousel, LazyPulseTooltip, LazyPulseBanner, LazyPulseBaseModal, LazyPulseChatAttachment, LazyPulseCheckRadioButton, LazyPulseClaimFeed, LazyPulseClaimMetric, LazyPulseCustomerAddress, LazyPulseCustomerAddresses, LazyPulseDataMetric, LazyPulseFeedback, LazyPulseFulfillmentInfo, LazyPulseInfoBanner, LazyPulseMessagingEvent, LazyPulseMessagingEventDivider, LazyPulseMessagingFeed, LazyPulseModal, LazyPulsePlatformAvatar, LazyPulseProductDisplay, LazyPulseReshipRefundResolutionDetails, LazyPulseStatusBadge, LazyPulseSuccessBanner, LazyPulseTagList, LazyPulseToggleDisplay, LazyPulseTrackingInfo, LazyPulseUserAvatar, LazyPulseWarningBanner, LazyPulseTable, LazyPulseTableGridSkeleton, LazyPulseTableSkeleton, LazyPulseAddBook, LazyPulseApiLogo, LazyPulseArmraLogo, LazyPulseArrowsRightLeft, LazyPulseBigCommerce, LazyPulseCart, LazyPulseCheckCircle, LazyPulseCheckoutBag, LazyPulseChevronLeft, LazyPulseCircleLogo, LazyPulseClaimInfoSubscribedRightArrows, LazyPulseClaimTodoApprovedDeniedSolidArrow, LazyPulseClaimTodoClosedSolidArrow, LazyPulseClaimTodoDashedArrow, LazyPulseClaimTodoOnholdDashedArrow, LazyPulseClaimTodoPendingDashedArrow, LazyPulseClaimTodoSolidLine, LazyPulseDatePicker, LazyPulseEarthGlobeTimezone, LazyPulseFolderCheck, LazyPulseFollowUp, LazyPulseIconApprove, LazyPulseIconArmra, LazyPulseIconAvatar, LazyPulseIconBuilding, LazyPulseIconCheck, LazyPulseIconClose, LazyPulseIconCreditCard, LazyPulseIconCustom, LazyPulseIconDanger, LazyPulseIconDollar, LazyPulseIconDrag, LazyPulseIconEdit, LazyPulseIconGoogle, LazyPulseIconInfo, LazyPulseIconLock, LazyPulseIconLogo, LazyPulseIconRefund, LazyPulseIconSave, LazyPulseIconSend, LazyPulseIconShipment, LazyPulseIconShopify, LazyPulseIconWarning, LazyPulseImageCancel, LazyPulseInbox, LazyPulseLineAlign, LazyPulseLineAlphabet, LazyPulseLineAngleDoubleLeft, LazyPulseLineAngleDoubleRight, LazyPulseLineAngleDown, LazyPulseLineAngleLeft, LazyPulseLineAngleRight, LazyPulseLineAngleUp, LazyPulseLineAppleAlt, LazyPulseLineArchive, LazyPulseLineArrow, LazyPulseLineArrowDownRight, LazyPulseLineArrowLeft, LazyPulseLineArrowRight, LazyPulseLineAt, LazyPulseLineBalanceScale, LazyPulseLineBars, LazyPulseLineBell, LazyPulseLineBold, LazyPulseLineBolt, LazyPulseLineBookMedical, LazyPulseLineBox, LazyPulseLineBrain, LazyPulseLineBuilding, LazyPulseLineCameraPlus, LazyPulseLineCameraQuestion, LazyPulseLineCancel, LazyPulseLineChart, LazyPulseLineChatBubbleUser, LazyPulseLineCheckCircle, LazyPulseLineCircle, LazyPulseLineClipboardAlt, LazyPulseLineClockThree, LazyPulseLineCodeBranch, LazyPulseLineCoins, LazyPulseLineCommentAlt, LazyPulseLineCommentAltBlock, LazyPulseLineCommentDots, LazyPulseLineCommentMessage, LazyPulseLineCommentQuestion, LazyPulseLineComparison, LazyPulseLineCopy, LazyPulseLineCornerUpLeftAlt, LazyPulseLineCornerUpRightAlt, LazyPulseLineCreditCard, LazyPulseLineDashboard, LazyPulseLineDownloadAlt, LazyPulseLineDraggabledots, LazyPulseLineEdit, LazyPulseLineEditAlt, LazyPulseLineEllipsisH, LazyPulseLineExclamationCircle, LazyPulseLineExclamationOctagon, LazyPulseLineExport, LazyPulseLineExternalLinkAlt, LazyPulseLineEye, LazyPulseLineEyeSlash, LazyPulseLineFileCopyAlt, LazyPulseLineFileLandscape, LazyPulseLineFilter, LazyPulseLineFire, LazyPulseLineFolder, LazyPulseLineFolderOpen, LazyPulseLineFont, LazyPulseLineGithubAlt, LazyPulseLineGlobe, LazyPulseLineImage, LazyPulseLineImageBroken, LazyPulseLineImport, LazyPulseLineInbox, LazyPulseLineInfoCircle, LazyPulseLineItalic, LazyPulseLineLeftIndent, LazyPulseLineLinkAlt, LazyPulseLineListOl, LazyPulseLineListUl, LazyPulseLineLock, LazyPulseLineMapPinAlt, LazyPulseLineMessage, LazyPulseLineMicrophone, LazyPulseLineMinusCircle, LazyPulseLineMoney, LazyPulseLineMoneyWithdraw, LazyPulseLineMoon, LazyPulseLineMultiply, LazyPulseLinePalette, LazyPulseLinePaperclip, LazyPulseLinePen, LazyPulseLinePhone, LazyPulseLinePlug, LazyPulseLinePlus, LazyPulseLinePlusCircle, LazyPulseLinePlusSquare, LazyPulseLineRedo, LazyPulseLineRefresh, LazyPulseLineRightIndentAlt, LazyPulseLineRobot, LazyPulseLineRocket, LazyPulseLineSearch, LazyPulseLineSetting, LazyPulseLineShield, LazyPulseLineShieldCheck, LazyPulseLineShoppingBag, LazyPulseLineSlack, LazyPulseLineSort, LazyPulseLineStar, LazyPulseLineSun, LazyPulseLineSwatchbook, LazyPulseLineSync, LazyPulseLineTable, LazyPulseLineTag, LazyPulseLineTimes, LazyPulseLineTimesCircle, LazyPulseLineToggleOff, LazyPulseLineToggleOn, LazyPulseLineTransaction, LazyPulseLineTrashAlt, LazyPulseLineTruck, LazyPulseLineUnderline, LazyPulseLineUpload, LazyPulseLineUsdCircle, LazyPulseLineUsersAlt, LazyPulseLineWrench, LazyPulseLoopreturns, LazyPulseMagentoLogo, LazyPulseNoResponse, LazyPulseOutlineCube, LazyPulseOutlineEnvelope, LazyPulseOutsideOp, LazyPulsePackage, LazyPulsePackageArrived, LazyPulsePlayCircle, LazyPulsePlusCircle, LazyPulseQueueList, LazyPulseRefreshResentMail, LazyPulseRiseaiLogo, LazyPulseShieldCheck, LazyPulseShipstation, LazyPulseShopifyAvatar, LazyPulseShopifyBag, LazyPulseSolidCheckCircle, LazyPulseSolidStar, LazyPulseTableDeleteColumn, LazyPulseTableDeleteRow, LazyPulseTableInsertColumnAfter, LazyPulseTableInsertColumnBefore, LazyPulseTableInsertRowAbove, LazyPulseTableInsertRowAfter, LazyPulseTableOptions, LazyPulseTableSettings, LazyPulseTipaltiLogo, LazyPulseTrackstar, LazyPulseXCircle, LazyPulseXMark, LazyPulseAccordionCard, LazyPulseBasicCard, LazyPulseItemsAccordion, LazyPulsePageIcon, LazyPulseShippingClaim, LazyPulseSingleClaim, LazyPulseTabbedNav, LazyPulseWarrantyClaim, LazyPulseButton, LazyPulseButtonCard, LazyPulseChatImageUploader, LazyPulseColorInput, LazyPulseCustomDatePicker, LazyPulseDateRangePicker, LazyPulseDropdown, LazyPulseIconButton, LazyPulseInput, LazyPulseLabelPopper, LazyPulseMessageBox, LazyPulseMultiDropdown, LazyPulseMultiSelectDropdown, LazyPulseOptionsMenu, LazyPulsePasswordInput, LazyPulseRadioButton, LazyPulseRadioQuestion, LazyPulseRangeSlider, LazyPulseRteFileComponent, LazyPulseRteMentionList, LazyPulseRteVideoComponent, LazyPulseRichTextEditor, LazyPulseSelect, LazyPulseTagSelect, LazyPulseTextArea, LazyPulseToggle, LazyPulseValidationGroup } from '#components'
const lazyGlobalComponents = [
  ["ComparisonCartFeatures", LazyComparisonCartFeatures],
["TextDivider", LazyTextDivider],
["CreateTestModal", LazyCreateTestModal],
["DuplicateTestModal", LazyDuplicateTestModal],
["EditTestNameModal", LazyEditTestNameModal],
["EndTestModal", LazyEndTestModal],
["StartTestModal", LazyStartTestModal],
["WidgetSelectionModal", LazyWidgetSelectionModal],
["InfoAccordion", LazyInfoAccordion],
["LinkAccordion", LazyLinkAccordion],
["PayoutAccordion", LazyPayoutAccordion],
["PayoutAccordionSkeleton", LazyPayoutAccordionSkeleton],
["PayoutComparisonChart", LazyPayoutComparisonChart],
["PayoutCompositionChart", LazyPayoutCompositionChart],
["DeactivateBrandModal", LazyDeactivateBrandModal],
["InviteUserModal", LazyInviteUserModal],
["AddressHistoryItem", LazyAddressHistoryItem],
["ActionObjectSummary", LazyActionObjectSummary],
["AmountBreakdown", LazyAmountBreakdown],
["AutomationBarChart", LazyAutomationBarChart],
["AutomationToolTrace", LazyAutomationToolTrace],
["ChartGranularityToggle", LazyChartGranularityToggle],
["ClaimAutomationDetail", LazyClaimAutomationDetail],
["FeedbackIssuesView", LazyFeedbackIssuesView],
["SegmentedToggle", LazySegmentedToggle],
["AllowedOrderTagsCard", LazyAllowedOrderTagsCard],
["ClaimAutomationTabs", LazyClaimAutomationTabs],
["EscalationTierStack", LazyEscalationTierStack],
["StoreModelPicker", LazyStoreModelPicker],
["BrandAuditModal", LazyBrandAuditModal],
["ScopeIndicator", LazyScopeIndicator],
["AccordionSection", LazyAccordionSection],
["ActivateStoreModal", LazyActivateStoreModal],
["AddProtectionModal", LazyAddProtectionModal],
["BasicQuestionModal", LazyBasicQuestionModal],
["ClaimAutomationDetailModal", LazyClaimAutomationDetailModal],
["ClaimAutomationFeedbackModal", LazyClaimAutomationFeedbackModal],
["CreateAdminUser", LazyCreateAdminUser],
["CreateApiToken", LazyCreateApiToken],
["CreateCategory", LazyCreateCategory],
["CreateMacro", LazyCreateMacro],
["CreateStoreModal", LazyCreateStoreModal],
["CreateWebhook", LazyCreateWebhook],
["DeactivateStoreModal", LazyDeactivateStoreModal],
["DeleteApiTokenModal", LazyDeleteApiTokenModal],
["DeleteCategoryModal", LazyDeleteCategoryModal],
["DeleteMacro", LazyDeleteMacro],
["DeleteSopModal", LazyDeleteSopModal],
["DeleteWebhookModal", LazyDeleteWebhookModal],
["MoveMacroModal", LazyMoveMacroModal],
["MoveStoreToDevelopmentModal", LazyMoveStoreToDevelopmentModal],
["MoveStoreToOnboardingModal", LazyMoveStoreToOnboardingModal],
["NewApiTokenModal", LazyNewApiTokenModal],
["ReInstallStore", LazyReInstallStore],
["RemoveProtection", LazyRemoveProtection],
["RenameCategory", LazyRenameCategory],
["RequestReinstall", LazyRequestReinstall],
["ResetOverrideMacroModal", LazyResetOverrideMacroModal],
["UpdateToActiveSopModal", LazyUpdateToActiveSopModal],
["UpdateToInactiveSopModal", LazyUpdateToInactiveSopModal],
["WebhookRequestResponse", LazyWebhookRequestResponse],
["ContactInformation", LazyContactInformation],
["CreateBigcommerceStore", LazyCreateBigcommerceStore],
["CreateDefaultStore", LazyCreateDefaultStore],
["CreateShopifyStore", LazyCreateShopifyStore],
["MerchantInformation", LazyMerchantInformation],
["DurationSelector", LazyDurationSelector],
["RangeRule", LazyRangeRule],
["RangeRuleSet", LazyRangeRuleSet],
["UnifiedPriceRule", LazyUnifiedPriceRule],
["UnifiedPriceRuleSet", LazyUnifiedPriceRuleSet],
["AccountDashboardFrame", LazyAccountDashboardFrame],
["MetricsSummary", LazyMetricsSummary],
["RevenueCalculator", LazyRevenueCalculator],
["SignIn", LazySignIn],
["WelcomeBack", LazyWelcomeBack],
["AvatarGroup", LazyAvatarGroup],
["PlatformAvatar", LazyPlatformAvatar],
["UserAvatar", LazyUserAvatar],
["FraudRiskBadge", LazyFraudRiskBadge],
["MetadataBadge", LazyMetadataBadge],
["NoFraudBadge", LazyNoFraudBadge],
["ProtectionStatusBadge", LazyProtectionStatusBadge],
["RiskLevelBadge", LazyRiskLevelBadge],
["StatusBadge", LazyStatusBadge],
["BuilderControl", LazyBuilderControl],
["BuilderEmptyState", LazyBuilderEmptyState],
["BuilderInspector", LazyBuilderInspector],
["BuilderNodeRow", LazyBuilderNodeRow],
["BuilderPalette", LazyBuilderPalette],
["BuilderTreeCanvas", LazyBuilderTreeCanvas],
["WidgetBuilderPanel", LazyWidgetBuilderPanel],
["BasicCard", LazyBasicCard],
["ConciergeCard", LazyConciergeCard],
["ChatAttachment", LazyChatAttachment],
["ChatImageUploader", LazyChatImageUploader],
["MessageBox", LazyMessageBox],
["ClaimPortalBlockView", LazyClaimPortalBlockView],
["ClaimPortalBuilderCanvas", LazyClaimPortalBuilderCanvas],
["ClaimPortalBuilderPanel", LazyClaimPortalBuilderPanel],
["ClaimSelectorBlockView", LazyClaimSelectorBlockView],
["PageSwitcher", LazyPageSwitcher],
["AIStatusBadge", LazyAIStatusBadge],
["AISuggestionBanner", LazyAISuggestionBanner],
["ClaimAssignee", LazyClaimAssignee],
["ClaimFeed", LazyClaimFeed],
["ClaimItemCard", LazyClaimItemCard],
["ClaimMetricRow", LazyClaimMetricRow],
["ClaimPeople", LazyClaimPeople],
["ClaimResolutionOptionsRadioGroup", LazyClaimResolutionOptionsRadioGroup],
["ClaimStateBadge", LazyClaimStateBadge],
["ClaimTypeCustomizer", LazyClaimTypeCustomizer],
["ClaimsInfoButton", LazyClaimsInfoButton],
["ClaimsTable", LazyClaimsTable],
["CreateClaimButton", LazyCreateClaimButton],
["EscalationPeek", LazyEscalationPeek],
["EscalationRecommendationCard", LazyEscalationRecommendationCard],
["EscalationReplyBox", LazyEscalationReplyBox],
["FulfillmentInfo", LazyFulfillmentInfo],
["IssueGallery", LazyIssueGallery],
["IssueGalleryCard", LazyIssueGalleryCard],
["ItemIssue", LazyItemIssue],
["PaymentSection", LazyPaymentSection],
["ReturnCard", LazyReturnCard],
["ReturnsFeed", LazyReturnsFeed],
["ReviewResolutionCard", LazyReviewResolutionCard],
["SetClaimType", LazySetClaimType],
["ShippingClaim", LazyShippingClaim],
["ShippingClaimMetric", LazyShippingClaimMetric],
["ShippingClaimPhotos", LazyShippingClaimPhotos],
["SingleClaim", LazySingleClaim],
["CustomerAddresses", LazyCustomerAddresses],
["FulfillmentTable", LazyFulfillmentTable],
["LiveTrackingStatus", LazyLiveTrackingStatus],
["SopTab", LazySopTab],
["TrackingInfo", LazyTrackingInfo],
["AddPaymentMethod", LazyAddPaymentMethod],
["AddPayoutMethod", LazyAddPayoutMethod],
["ApproveClaim", LazyApproveClaim],
["ApproveResolveExternallyClaim", LazyApproveResolveExternallyClaim],
["ClaimsInfoModal", LazyClaimsInfoModal],
["CloseClaim", LazyCloseClaim],
["CreateClaimSuccessModal", LazyCreateClaimSuccessModal],
["CreateInternalClaimModal", LazyCreateInternalClaimModal],
["DenyClaim", LazyDenyClaim],
["DenySuggestionFeedbackModal", LazyDenySuggestionFeedbackModal],
["DismissClaim", LazyDismissClaim],
["EditClaimTypeModal", LazyEditClaimTypeModal],
["EditCustomerEmail", LazyEditCustomerEmail],
["EditShippingAddress", LazyEditShippingAddress],
["InStoreShippingClaimModal", LazyInStoreShippingClaimModal],
["InStoreWarrantyModal", LazyInStoreWarrantyModal],
["MoveToApprovedModal", LazyMoveToApprovedModal],
["MoveToClosedModal", LazyMoveToClosedModal],
["MoveToDeniedModal", LazyMoveToDeniedModal],
["OnHoldClaim", LazyOnHoldClaim],
["PendingClaim", LazyPendingClaim],
["PolicyTraceModal", LazyPolicyTraceModal],
["ResetClaimModal", LazyResetClaimModal],
["ShippingAddressHistoryModal", LazyShippingAddressHistoryModal],
["ShippingClaimForm", LazyShippingClaimForm],
["TakeoverReasonModal", LazyTakeoverReasonModal],
["ToDoClaim", LazyToDoClaim],
["ValidateWarrantyModal", LazyValidateWarrantyModal],
["WarrantyClaimForm", LazyWarrantyClaimForm],
["ApproveClaimCustom", LazyApproveClaimCustom],
["FlatRateType", LazyFlatRateType],
["FullDraftOrder", LazyFullDraftOrder],
["FullFlatRate", LazyFullFlatRate],
["FullRefund", LazyFullRefund],
["FullReship", LazyFullReship],
["FullStoreCredit", LazyFullStoreCredit],
["OverrideShippingAmount", LazyOverrideShippingAmount],
["RefundItem", LazyRefundItem],
["RefundShipping", LazyRefundShipping],
["ReshipRefundResolutionDetails", LazyReshipRefundResolutionDetails],
["ResolutionBreakdown", LazyResolutionBreakdown],
["WarrantiesTable", LazyWarrantiesTable],
["WarrantyClaim", LazyWarrantyClaim],
["LoaderBar", LazyLoaderBar],
["CustomerAddressesModal", LazyCustomerAddressesModal],
["CustomerDetail", LazyCustomerDetail],
["CustomerFilters", LazyCustomerFilters],
["CustomerHistoryStrip", LazyCustomerHistoryStrip],
["CustomerListTable", LazyCustomerListTable],
["CustomerMetricCard", LazyCustomerMetricCard],
["CustomerMetricRow", LazyCustomerMetricRow],
["CustomerMetrics", LazyCustomerMetrics],
["CustomerName", LazyCustomerName],
["CustomerOrderHistoryTable", LazyCustomerOrderHistoryTable],
["CustomerPendingBanner", LazyCustomerPendingBanner],
["CustomerProtectedOrderHistoryTable", LazyCustomerProtectedOrderHistoryTable],
["CustomerSearch", LazyCustomerSearch],
["CustomerSortControl", LazyCustomerSortControl],
["CustomerSummaryTiles", LazyCustomerSummaryTiles],
["CustomerTable", LazyCustomerTable],
["CustomerTags", LazyCustomerTags],
["DangerThresholdTile", LazyDangerThresholdTile],
["FreshnessStamp", LazyFreshnessStamp],
["LegacyCustomerDetail", LazyLegacyCustomerDetail],
["LegacyCustomerList", LazyLegacyCustomerList],
["SortResetNotice", LazySortResetNotice],
["UsdMarker", LazyUsdMarker],
["ClaimPortalView", LazyClaimPortalView],
["FontStyleRadioGroup", LazyFontStyleRadioGroup],
["MockCartPreview", LazyMockCartPreview],
["PageMetadataView", LazyPageMetadataView],
["PhoneFrame", LazyPhoneFrame],
["PreviewUnavailableNotice", LazyPreviewUnavailableNotice],
["AnalyticsTile", LazyAnalyticsTile],
["ClaimsByTypeTile", LazyClaimsByTypeTile],
["TopProductsWithShippingClaimsTile", LazyTopProductsWithShippingClaimsTile],
["ABTestDataDisplay", LazyABTestDataDisplay],
["DataDisplay", LazyDataDisplay],
["DataMetric", LazyDataMetric],
["DateFilter", LazyDateFilter],
["ProductDisplay", LazyProductDisplay],
["ProductResolution", LazyProductResolution],
["SettingsGeneralTagging", LazySettingsGeneralTagging],
["StoreCreditOptions", LazyStoreCreditOptions],
["ToggleDisplay", LazyToggleDisplay],
["MethodSettings", LazyMethodSettings],
["AddFilterButton", LazyAddFilterButton],
["DesktopFilterButton", LazyDesktopFilterButton],
["FilterButton", LazyFilterButton],
["FilterOptionRow", LazyFilterOptionRow],
["Filters", LazyFilters],
["MobileFilterButton", LazyMobileFilterButton],
["ResponsiveTable", LazyResponsiveTable],
["TableFilter", LazyTableFilter],
["TablePagination", LazyTablePagination],
["SortButton", LazySortButton],
["AppCard", LazyAppCard],
["AppStatusBadge", LazyAppStatusBadge],
["ClientSecretField", LazyClientSecretField],
["CreateAppModal", LazyCreateAppModal],
["InviteOrgMember", LazyInviteOrgMember],
["RedirectUriList", LazyRedirectUriList],
["ScopeSelector", LazyScopeSelector],
["EmailBlockView", LazyEmailBlockView],
["EmailBuilderControl", LazyEmailBuilderControl],
["EmailBuilderEmptyState", LazyEmailBuilderEmptyState],
["EmailBuilderInspector", LazyEmailBuilderInspector],
["EmailBuilderPalette", LazyEmailBuilderPalette],
["EmailBuilderPanel", LazyEmailBuilderPanel],
["EmailBuilderPreview", LazyEmailBuilderPreview],
["EmailDesignerSidebar", LazyEmailDesignerSidebar],
["SidebarAccordion", LazySidebarAccordion],
["SidebarSection", LazySidebarSection],
["WidgetDesignerSidebar", LazyWidgetDesignerSidebar],
["BillingJobs", LazyBillingJobs],
["JobsList", LazyJobsList],
["GlobalMacroCard", LazyGlobalMacroCard],
["GlobalMacroCategoryList", LazyGlobalMacroCategoryList],
["ImpersonationBanner", LazyImpersonationBanner],
["ImpersonationTargetModal", LazyImpersonationTargetModal],
["ThemeRunTerminal", LazyThemeRunTerminal],
["InfoModalBuilderCanvas", LazyInfoModalBuilderCanvas],
["InfoModalBuilderPanel", LazyInfoModalBuilderPanel],
["InfoModalDesignerSidebar", LazyInfoModalDesignerSidebar],
["InfoModalPreview", LazyInfoModalPreview],
["DashboardIndex", LazyDashboardIndex],
["DashboardIndividual", LazyDashboardIndividual],
["LightModeOnly", LazyLightModeOnly],
["PreviewTemplate", LazyPreviewTemplate],
["SidebarLayout", LazySidebarLayout],
["CodeEditorModal", LazyCodeEditorModal],
["DeleteInfoModalModal", LazyDeleteInfoModalModal],
["DraftModal", LazyDraftModal],
["FreshInstallDeploymentModal", LazyFreshInstallDeploymentModal],
["GetCodeModal", LazyGetCodeModal],
["InfoModalTypeModal", LazyInfoModalTypeModal],
["PublishEmailModal", LazyPublishEmailModal],
["PublishSuccessModal", LazyPublishSuccessModal],
["PublishWidgetModal", LazyPublishWidgetModal],
["SenderSignatureModal", LazySenderSignatureModal],
["SenderSignatureSuccessModal", LazySenderSignatureSuccessModal],
["SuccessModal", LazySuccessModal],
["UnsavedChangesModal", LazyUnsavedChangesModal],
["WidgetStyleModal", LazyWidgetStyleModal],
["WidgetTypeModal", LazyWidgetTypeModal],
["DashboardSingleLayout", LazyDashboardSingleLayout],
["MacroCard", LazyMacroCard],
["MacroCategoryButtonMenu", LazyMacroCategoryButtonMenu],
["MacroCategoryList", LazyMacroCategoryList],
["MacroDetails", LazyMacroDetails],
["CategoryFilter", LazyCategoryFilter],
["MarketplaceAppCard", LazyMarketplaceAppCard],
["AddMacroModal", LazyAddMacroModal],
["AutomationEvent", LazyAutomationEvent],
["DownloadTranscriptButton", LazyDownloadTranscriptButton],
["MessagingEvent", LazyMessagingEvent],
["MessagingEventDivider", LazyMessagingEventDivider],
["MessagingFeed", LazyMessagingFeed],
["MethodList", LazyMethodList],
["AddTagModal", LazyAddTagModal],
["ConfirmationModal", LazyConfirmationModal],
["CreateBrandModal", LazyCreateBrandModal],
["CreateDeploymentModal", LazyCreateDeploymentModal],
["CreateReturnModal", LazyCreateReturnModal],
["CreateReviewModal", LazyCreateReviewModal],
["CreateShopifyAppModal", LazyCreateShopifyAppModal],
["DeleteStoreCreditModal", LazyDeleteStoreCreditModal],
["EditBrandModal", LazyEditBrandModal],
["EditWarrantyDurationModal", LazyEditWarrantyDurationModal],
["MFAEmailHelp", LazyMFAEmailHelp],
["MFAHelp", LazyMFAHelp],
["MFAManualCodeModal", LazyMFAManualCodeModal],
["MFAVerifyHelp", LazyMFAVerifyHelp],
["OrderNotificationSettingsModal", LazyOrderNotificationSettingsModal],
["PublishClaimPortalConfirmation", LazyPublishClaimPortalConfirmation],
["NavAccordion", LazyNavAccordion],
["NavDivider", LazyNavDivider],
["NavGroupTitle", LazyNavGroupTitle],
["NavItem", LazyNavItem],
["NavItems", LazyNavItems],
["SideNav", LazySideNav],
["TabbedNav", LazyTabbedNav],
["Notification", LazyNotification],
["NotificationContent", LazyNotificationContent],
["OrdersTable", LazyOrdersTable],
["ProtectedOrderItemCard", LazyProtectedOrderItemCard],
["ProtectedOrderMetricRow", LazyProtectedOrderMetricRow],
["ProtectionButton", LazyProtectionButton],
["PayoutBillsTable", LazyPayoutBillsTable],
["PayoutInfoModal", LazyPayoutInfoModal],
["PriorCycleCard", LazyPriorCycleCard],
["ReimbursementModal", LazyReimbursementModal],
["StatisticTile", LazyStatisticTile],
["CreatePersonalAccessTokenModal", LazyCreatePersonalAccessTokenModal],
["NewPersonalAccessTokenModal", LazyNewPersonalAccessTokenModal],
["PersonalAccessTokenManager", LazyPersonalAccessTokenManager],
["PersonalAccessTokenTable", LazyPersonalAccessTokenTable],
["RenamePersonalAccessTokenModal", LazyRenamePersonalAccessTokenModal],
["ProductsTable", LazyProductsTable],
["SyncShopifyButton", LazySyncShopifyButton],
["WarrantyCell", LazyWarrantyCell],
["WarrantyStatusCell", LazyWarrantyStatusCell],
["AverageCard", LazyAverageCard],
["DistributionCard", LazyDistributionCard],
["MetricsRow", LazyMetricsRow],
["RatingStars", LazyRatingStars],
["ReviewNoteItem", LazyReviewNoteItem],
["ReviewNotesDrawer", LazyReviewNotesDrawer],
["TrendCard", LazyTrendCard],
["AddItemFromOrderModal", LazyAddItemFromOrderModal],
["SearchInput", LazySearchInput],
["SearchModal", LazySearchModal],
["SearchProductModal", LazySearchProductModal],
["HalloweenDecor", LazyHalloweenDecor],
["SeasonalLogo", LazySeasonalLogo],
["ThanksgivingDecor", LazyThanksgivingDecor],
["ThanksgivingFeast", LazyThanksgivingFeast],
["ThanksgivingPardon", LazyThanksgivingPardon],
["ThanksgivingTurkey", LazyThanksgivingTurkey],
["CoverageModeSelector", LazyCoverageModeSelector],
["CustomerAcknowledgmentCard", LazyCustomerAcknowledgmentCard],
["EffectiveWindowBanner", LazyEffectiveWindowBanner],
["EscalationsSettings", LazyEscalationsSettings],
["EvidencePill", LazyEvidencePill],
["ResolutionValueBasisCard", LazyResolutionValueBasisCard],
["RiskRoutingCard", LazyRiskRoutingCard],
["ShopifyRateTableCard", LazyShopifyRateTableCard],
["SlackIntegrationCard", LazySlackIntegrationCard],
["CustomTagRuleModal", LazyCustomTagRuleModal],
["CustomTagRuleRow", LazyCustomTagRuleRow],
["CustomTagsList", LazyCustomTagsList],
["PreviewSidebar", LazyPreviewSidebar],
["StepHeader", LazyStepHeader],
["TemplateTokenInput", LazyTemplateTokenInput],
["VariableChips", LazyVariableChips],
["AutomationReason", LazyAutomationReason],
["CodeEditor", LazyCodeEditor],
["CopyText", LazyCopyText],
["CustomerAddress", LazyCustomerAddress],
["EditButton", LazyEditButton],
["MarkdownText", LazyMarkdownText],
["ApiTokenCard", LazyApiTokenCard],
["ApiTokenCardSkeleton", LazyApiTokenCardSkeleton],
["EmptyState", LazyEmptyState],
["DropArea", LazyDropArea],
["MediaUploader", LazyMediaUploader],
["PageIcon", LazyPageIcon],
["SharedFooter", LazySharedFooter],
["BasicModal", LazyBasicModal],
["SimplePopover", LazySimplePopover],
["SelectionGroup", LazySelectionGroup],
["ErrorGroup", LazyErrorGroup],
["GenerateSopsCard", LazyGenerateSopsCard],
["HelpDeskConsentModal", LazyHelpDeskConsentModal],
["SlackChannelChecklist", LazySlackChannelChecklist],
["SlackConsentModal", LazySlackConsentModal],
["SlackSopsCard", LazySlackSopsCard],
["SopListItem", LazySopListItem],
["RedeemedText", LazyRedeemedText],
["AccountRollupHeader", LazyAccountRollupHeader],
["AdminStoreGroupingControls", LazyAdminStoreGroupingControls],
["StoreDisplay", LazyStoreDisplay],
["StoreSelect", LazyStoreSelect],
["StoreSelectButton", LazyStoreSelectButton],
["TeamMembersInfoButton", LazyTeamMembersInfoButton],
["TeamMembersTable", LazyTeamMembersTable],
["AccessLevelSelect", LazyAccessLevelSelect],
["UserRoleBadge", LazyUserRoleBadge],
["CreateTeamMember", LazyCreateTeamMember],
["TeamMembersEntitlementsCard", LazyTeamMembersEntitlementsCard],
["TeamMembersInfoModal", LazyTeamMembersInfoModal],
["ThemeSwitch", LazyThemeSwitch],
["NotificationToast", LazyNotificationToast],
["ToastController", LazyToastController],
["DownloadUploadProducts", LazyDownloadUploadProducts],
["PricingAccordion", LazyPricingAccordion],
["WarrantyPricingDisplay", LazyWarrantyPricingDisplay],
["WarrantyRuleSelect", LazyWarrantyRuleSelect],
["WebhookCard", LazyWebhookCard],
["WebhookCardSkeleton", LazyWebhookCardSkeleton],
["WebhookTopicGroup", LazyWebhookTopicGroup],
["CheckoutWidget", LazyCheckoutWidget],
["IncludedCheckoutPreview", LazyIncludedCheckoutPreview],
["TileFeatureList", LazyTileFeatureList],
["PulseAiProductFinderModal", LazyPulseAiProductFinderModal],
["PulseConfirmShippingAddress", LazyPulseConfirmShippingAddress],
["PulseDeliveryIssueDetails", LazyPulseDeliveryIssueDetails],
["PulseDeliveryIssueDropdown", LazyPulseDeliveryIssueDropdown],
["PulseDeliveryIssueOptions", LazyPulseDeliveryIssueOptions],
["PulseItemCard", LazyPulseItemCard],
["PulseItemIssueCard", LazyPulseItemIssueCard],
["PulseItemIssueDetailModal", LazyPulseItemIssueDetailModal],
["PulseItemIssueDetailModalForm", LazyPulseItemIssueDetailModalForm],
["PulseItemIssueDetailModalProgressBar", LazyPulseItemIssueDetailModalProgressBar],
["PulseItemIssueDetailModalSelectCount", LazyPulseItemIssueDetailModalSelectCount],
["PulseItemIssueDetailModalSelectGranularity", LazyPulseItemIssueDetailModalSelectGranularity],
["PulseItemIssueDetails", LazyPulseItemIssueDetails],
["PulseOrderIssueOptions", LazyPulseOrderIssueOptions],
["PulseProductNotFoundForm", LazyPulseProductNotFoundForm],
["PulseRendered", LazyPulseRendered],
["PulseResolutionOptions", LazyPulseResolutionOptions],
["PulseSearchWarrantyProductsModal", LazyPulseSearchWarrantyProductsModal],
["PulseShippingAddress", LazyPulseShippingAddress],
["PulseUnavailableItemsResolution", LazyPulseUnavailableItemsResolution],
["PulseUploadedReceipts", LazyPulseUploadedReceipts],
["PulseContactInfoStep", LazyPulseContactInfoStep],
["PulseDateOfPurchaseStep", LazyPulseDateOfPurchaseStep],
["PulseProductSearchStep", LazyPulseProductSearchStep],
["PulseReceiptStep", LazyPulseReceiptStep],
["PulseReceiptUploadSection", LazyPulseReceiptUploadSection],
["PulseResolutionStep", LazyPulseResolutionStep],
["PulseBadge", LazyPulseBadge],
["PulseEmptyState", LazyPulseEmptyState],
["PulseLoadingSpinner", LazyPulseLoadingSpinner],
["PulseMediaCarousel", LazyPulseMediaCarousel],
["PulseTooltip", LazyPulseTooltip],
["PulseBanner", LazyPulseBanner],
["PulseBaseModal", LazyPulseBaseModal],
["PulseChatAttachment", LazyPulseChatAttachment],
["PulseCheckRadioButton", LazyPulseCheckRadioButton],
["PulseClaimFeed", LazyPulseClaimFeed],
["PulseClaimMetric", LazyPulseClaimMetric],
["PulseCustomerAddress", LazyPulseCustomerAddress],
["PulseCustomerAddresses", LazyPulseCustomerAddresses],
["PulseDataMetric", LazyPulseDataMetric],
["PulseFeedback", LazyPulseFeedback],
["PulseFulfillmentInfo", LazyPulseFulfillmentInfo],
["PulseInfoBanner", LazyPulseInfoBanner],
["PulseMessagingEvent", LazyPulseMessagingEvent],
["PulseMessagingEventDivider", LazyPulseMessagingEventDivider],
["PulseMessagingFeed", LazyPulseMessagingFeed],
["PulseModal", LazyPulseModal],
["PulsePlatformAvatar", LazyPulsePlatformAvatar],
["PulseProductDisplay", LazyPulseProductDisplay],
["PulseReshipRefundResolutionDetails", LazyPulseReshipRefundResolutionDetails],
["PulseStatusBadge", LazyPulseStatusBadge],
["PulseSuccessBanner", LazyPulseSuccessBanner],
["PulseTagList", LazyPulseTagList],
["PulseToggleDisplay", LazyPulseToggleDisplay],
["PulseTrackingInfo", LazyPulseTrackingInfo],
["PulseUserAvatar", LazyPulseUserAvatar],
["PulseWarningBanner", LazyPulseWarningBanner],
["PulseTable", LazyPulseTable],
["PulseTableGridSkeleton", LazyPulseTableGridSkeleton],
["PulseTableSkeleton", LazyPulseTableSkeleton],
["PulseAddBook", LazyPulseAddBook],
["PulseApiLogo", LazyPulseApiLogo],
["PulseArmraLogo", LazyPulseArmraLogo],
["PulseArrowsRightLeft", LazyPulseArrowsRightLeft],
["PulseBigCommerce", LazyPulseBigCommerce],
["PulseCart", LazyPulseCart],
["PulseCheckCircle", LazyPulseCheckCircle],
["PulseCheckoutBag", LazyPulseCheckoutBag],
["PulseChevronLeft", LazyPulseChevronLeft],
["PulseCircleLogo", LazyPulseCircleLogo],
["PulseClaimInfoSubscribedRightArrows", LazyPulseClaimInfoSubscribedRightArrows],
["PulseClaimTodoApprovedDeniedSolidArrow", LazyPulseClaimTodoApprovedDeniedSolidArrow],
["PulseClaimTodoClosedSolidArrow", LazyPulseClaimTodoClosedSolidArrow],
["PulseClaimTodoDashedArrow", LazyPulseClaimTodoDashedArrow],
["PulseClaimTodoOnholdDashedArrow", LazyPulseClaimTodoOnholdDashedArrow],
["PulseClaimTodoPendingDashedArrow", LazyPulseClaimTodoPendingDashedArrow],
["PulseClaimTodoSolidLine", LazyPulseClaimTodoSolidLine],
["PulseDatePicker", LazyPulseDatePicker],
["PulseEarthGlobeTimezone", LazyPulseEarthGlobeTimezone],
["PulseFolderCheck", LazyPulseFolderCheck],
["PulseFollowUp", LazyPulseFollowUp],
["PulseIconApprove", LazyPulseIconApprove],
["PulseIconArmra", LazyPulseIconArmra],
["PulseIconAvatar", LazyPulseIconAvatar],
["PulseIconBuilding", LazyPulseIconBuilding],
["PulseIconCheck", LazyPulseIconCheck],
["PulseIconClose", LazyPulseIconClose],
["PulseIconCreditCard", LazyPulseIconCreditCard],
["PulseIconCustom", LazyPulseIconCustom],
["PulseIconDanger", LazyPulseIconDanger],
["PulseIconDollar", LazyPulseIconDollar],
["PulseIconDrag", LazyPulseIconDrag],
["PulseIconEdit", LazyPulseIconEdit],
["PulseIconGoogle", LazyPulseIconGoogle],
["PulseIconInfo", LazyPulseIconInfo],
["PulseIconLock", LazyPulseIconLock],
["PulseIconLogo", LazyPulseIconLogo],
["PulseIconRefund", LazyPulseIconRefund],
["PulseIconSave", LazyPulseIconSave],
["PulseIconSend", LazyPulseIconSend],
["PulseIconShipment", LazyPulseIconShipment],
["PulseIconShopify", LazyPulseIconShopify],
["PulseIconWarning", LazyPulseIconWarning],
["PulseImageCancel", LazyPulseImageCancel],
["PulseInbox", LazyPulseInbox],
["PulseLineAlign", LazyPulseLineAlign],
["PulseLineAlphabet", LazyPulseLineAlphabet],
["PulseLineAngleDoubleLeft", LazyPulseLineAngleDoubleLeft],
["PulseLineAngleDoubleRight", LazyPulseLineAngleDoubleRight],
["PulseLineAngleDown", LazyPulseLineAngleDown],
["PulseLineAngleLeft", LazyPulseLineAngleLeft],
["PulseLineAngleRight", LazyPulseLineAngleRight],
["PulseLineAngleUp", LazyPulseLineAngleUp],
["PulseLineAppleAlt", LazyPulseLineAppleAlt],
["PulseLineArchive", LazyPulseLineArchive],
["PulseLineArrow", LazyPulseLineArrow],
["PulseLineArrowDownRight", LazyPulseLineArrowDownRight],
["PulseLineArrowLeft", LazyPulseLineArrowLeft],
["PulseLineArrowRight", LazyPulseLineArrowRight],
["PulseLineAt", LazyPulseLineAt],
["PulseLineBalanceScale", LazyPulseLineBalanceScale],
["PulseLineBars", LazyPulseLineBars],
["PulseLineBell", LazyPulseLineBell],
["PulseLineBold", LazyPulseLineBold],
["PulseLineBolt", LazyPulseLineBolt],
["PulseLineBookMedical", LazyPulseLineBookMedical],
["PulseLineBox", LazyPulseLineBox],
["PulseLineBrain", LazyPulseLineBrain],
["PulseLineBuilding", LazyPulseLineBuilding],
["PulseLineCameraPlus", LazyPulseLineCameraPlus],
["PulseLineCameraQuestion", LazyPulseLineCameraQuestion],
["PulseLineCancel", LazyPulseLineCancel],
["PulseLineChart", LazyPulseLineChart],
["PulseLineChatBubbleUser", LazyPulseLineChatBubbleUser],
["PulseLineCheckCircle", LazyPulseLineCheckCircle],
["PulseLineCircle", LazyPulseLineCircle],
["PulseLineClipboardAlt", LazyPulseLineClipboardAlt],
["PulseLineClockThree", LazyPulseLineClockThree],
["PulseLineCodeBranch", LazyPulseLineCodeBranch],
["PulseLineCoins", LazyPulseLineCoins],
["PulseLineCommentAlt", LazyPulseLineCommentAlt],
["PulseLineCommentAltBlock", LazyPulseLineCommentAltBlock],
["PulseLineCommentDots", LazyPulseLineCommentDots],
["PulseLineCommentMessage", LazyPulseLineCommentMessage],
["PulseLineCommentQuestion", LazyPulseLineCommentQuestion],
["PulseLineComparison", LazyPulseLineComparison],
["PulseLineCopy", LazyPulseLineCopy],
["PulseLineCornerUpLeftAlt", LazyPulseLineCornerUpLeftAlt],
["PulseLineCornerUpRightAlt", LazyPulseLineCornerUpRightAlt],
["PulseLineCreditCard", LazyPulseLineCreditCard],
["PulseLineDashboard", LazyPulseLineDashboard],
["PulseLineDownloadAlt", LazyPulseLineDownloadAlt],
["PulseLineDraggabledots", LazyPulseLineDraggabledots],
["PulseLineEdit", LazyPulseLineEdit],
["PulseLineEditAlt", LazyPulseLineEditAlt],
["PulseLineEllipsisH", LazyPulseLineEllipsisH],
["PulseLineExclamationCircle", LazyPulseLineExclamationCircle],
["PulseLineExclamationOctagon", LazyPulseLineExclamationOctagon],
["PulseLineExport", LazyPulseLineExport],
["PulseLineExternalLinkAlt", LazyPulseLineExternalLinkAlt],
["PulseLineEye", LazyPulseLineEye],
["PulseLineEyeSlash", LazyPulseLineEyeSlash],
["PulseLineFileCopyAlt", LazyPulseLineFileCopyAlt],
["PulseLineFileLandscape", LazyPulseLineFileLandscape],
["PulseLineFilter", LazyPulseLineFilter],
["PulseLineFire", LazyPulseLineFire],
["PulseLineFolder", LazyPulseLineFolder],
["PulseLineFolderOpen", LazyPulseLineFolderOpen],
["PulseLineFont", LazyPulseLineFont],
["PulseLineGithubAlt", LazyPulseLineGithubAlt],
["PulseLineGlobe", LazyPulseLineGlobe],
["PulseLineImage", LazyPulseLineImage],
["PulseLineImageBroken", LazyPulseLineImageBroken],
["PulseLineImport", LazyPulseLineImport],
["PulseLineInbox", LazyPulseLineInbox],
["PulseLineInfoCircle", LazyPulseLineInfoCircle],
["PulseLineItalic", LazyPulseLineItalic],
["PulseLineLeftIndent", LazyPulseLineLeftIndent],
["PulseLineLinkAlt", LazyPulseLineLinkAlt],
["PulseLineListOl", LazyPulseLineListOl],
["PulseLineListUl", LazyPulseLineListUl],
["PulseLineLock", LazyPulseLineLock],
["PulseLineMapPinAlt", LazyPulseLineMapPinAlt],
["PulseLineMessage", LazyPulseLineMessage],
["PulseLineMicrophone", LazyPulseLineMicrophone],
["PulseLineMinusCircle", LazyPulseLineMinusCircle],
["PulseLineMoney", LazyPulseLineMoney],
["PulseLineMoneyWithdraw", LazyPulseLineMoneyWithdraw],
["PulseLineMoon", LazyPulseLineMoon],
["PulseLineMultiply", LazyPulseLineMultiply],
["PulseLinePalette", LazyPulseLinePalette],
["PulseLinePaperclip", LazyPulseLinePaperclip],
["PulseLinePen", LazyPulseLinePen],
["PulseLinePhone", LazyPulseLinePhone],
["PulseLinePlug", LazyPulseLinePlug],
["PulseLinePlus", LazyPulseLinePlus],
["PulseLinePlusCircle", LazyPulseLinePlusCircle],
["PulseLinePlusSquare", LazyPulseLinePlusSquare],
["PulseLineRedo", LazyPulseLineRedo],
["PulseLineRefresh", LazyPulseLineRefresh],
["PulseLineRightIndentAlt", LazyPulseLineRightIndentAlt],
["PulseLineRobot", LazyPulseLineRobot],
["PulseLineRocket", LazyPulseLineRocket],
["PulseLineSearch", LazyPulseLineSearch],
["PulseLineSetting", LazyPulseLineSetting],
["PulseLineShield", LazyPulseLineShield],
["PulseLineShieldCheck", LazyPulseLineShieldCheck],
["PulseLineShoppingBag", LazyPulseLineShoppingBag],
["PulseLineSlack", LazyPulseLineSlack],
["PulseLineSort", LazyPulseLineSort],
["PulseLineStar", LazyPulseLineStar],
["PulseLineSun", LazyPulseLineSun],
["PulseLineSwatchbook", LazyPulseLineSwatchbook],
["PulseLineSync", LazyPulseLineSync],
["PulseLineTable", LazyPulseLineTable],
["PulseLineTag", LazyPulseLineTag],
["PulseLineTimes", LazyPulseLineTimes],
["PulseLineTimesCircle", LazyPulseLineTimesCircle],
["PulseLineToggleOff", LazyPulseLineToggleOff],
["PulseLineToggleOn", LazyPulseLineToggleOn],
["PulseLineTransaction", LazyPulseLineTransaction],
["PulseLineTrashAlt", LazyPulseLineTrashAlt],
["PulseLineTruck", LazyPulseLineTruck],
["PulseLineUnderline", LazyPulseLineUnderline],
["PulseLineUpload", LazyPulseLineUpload],
["PulseLineUsdCircle", LazyPulseLineUsdCircle],
["PulseLineUsersAlt", LazyPulseLineUsersAlt],
["PulseLineWrench", LazyPulseLineWrench],
["PulseLoopreturns", LazyPulseLoopreturns],
["PulseMagentoLogo", LazyPulseMagentoLogo],
["PulseNoResponse", LazyPulseNoResponse],
["PulseOutlineCube", LazyPulseOutlineCube],
["PulseOutlineEnvelope", LazyPulseOutlineEnvelope],
["PulseOutsideOp", LazyPulseOutsideOp],
["PulsePackage", LazyPulsePackage],
["PulsePackageArrived", LazyPulsePackageArrived],
["PulsePlayCircle", LazyPulsePlayCircle],
["PulsePlusCircle", LazyPulsePlusCircle],
["PulseQueueList", LazyPulseQueueList],
["PulseRefreshResentMail", LazyPulseRefreshResentMail],
["PulseRiseaiLogo", LazyPulseRiseaiLogo],
["PulseShieldCheck", LazyPulseShieldCheck],
["PulseShipstation", LazyPulseShipstation],
["PulseShopifyAvatar", LazyPulseShopifyAvatar],
["PulseShopifyBag", LazyPulseShopifyBag],
["PulseSolidCheckCircle", LazyPulseSolidCheckCircle],
["PulseSolidStar", LazyPulseSolidStar],
["PulseTableDeleteColumn", LazyPulseTableDeleteColumn],
["PulseTableDeleteRow", LazyPulseTableDeleteRow],
["PulseTableInsertColumnAfter", LazyPulseTableInsertColumnAfter],
["PulseTableInsertColumnBefore", LazyPulseTableInsertColumnBefore],
["PulseTableInsertRowAbove", LazyPulseTableInsertRowAbove],
["PulseTableInsertRowAfter", LazyPulseTableInsertRowAfter],
["PulseTableOptions", LazyPulseTableOptions],
["PulseTableSettings", LazyPulseTableSettings],
["PulseTipaltiLogo", LazyPulseTipaltiLogo],
["PulseTrackstar", LazyPulseTrackstar],
["PulseXCircle", LazyPulseXCircle],
["PulseXMark", LazyPulseXMark],
["PulseAccordionCard", LazyPulseAccordionCard],
["PulseBasicCard", LazyPulseBasicCard],
["PulseItemsAccordion", LazyPulseItemsAccordion],
["PulsePageIcon", LazyPulsePageIcon],
["PulseShippingClaim", LazyPulseShippingClaim],
["PulseSingleClaim", LazyPulseSingleClaim],
["PulseTabbedNav", LazyPulseTabbedNav],
["PulseWarrantyClaim", LazyPulseWarrantyClaim],
["PulseButton", LazyPulseButton],
["PulseButtonCard", LazyPulseButtonCard],
["PulseChatImageUploader", LazyPulseChatImageUploader],
["PulseColorInput", LazyPulseColorInput],
["PulseCustomDatePicker", LazyPulseCustomDatePicker],
["PulseDateRangePicker", LazyPulseDateRangePicker],
["PulseDropdown", LazyPulseDropdown],
["PulseIconButton", LazyPulseIconButton],
["PulseInput", LazyPulseInput],
["PulseLabelPopper", LazyPulseLabelPopper],
["PulseMessageBox", LazyPulseMessageBox],
["PulseMultiDropdown", LazyPulseMultiDropdown],
["PulseMultiSelectDropdown", LazyPulseMultiSelectDropdown],
["PulseOptionsMenu", LazyPulseOptionsMenu],
["PulsePasswordInput", LazyPulsePasswordInput],
["PulseRadioButton", LazyPulseRadioButton],
["PulseRadioQuestion", LazyPulseRadioQuestion],
["PulseRangeSlider", LazyPulseRangeSlider],
["PulseRteFileComponent", LazyPulseRteFileComponent],
["PulseRteMentionList", LazyPulseRteMentionList],
["PulseRteVideoComponent", LazyPulseRteVideoComponent],
["PulseRichTextEditor", LazyPulseRichTextEditor],
["PulseSelect", LazyPulseSelect],
["PulseTagSelect", LazyPulseTagSelect],
["PulseTextArea", LazyPulseTextArea],
["PulseToggle", LazyPulseToggle],
["PulseValidationGroup", LazyPulseValidationGroup],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
